import '@gitbook/spine-tokens/spine-tokens.css';
import '@gitbook/react-uikit/src/theme/css/design-tokens.css';
import '@gitbook/spine-css/preflight.css';
import './app.css';
import { createRoot } from 'react-dom/client';

import { releaseVersion, webConfig } from '@gitbook/env';
import { initializeSentry } from '@gitbook/util-debug';
import { assert } from '@gitbook/util-ts';

import { Application } from './Application';
import { initializeAuth } from './state';

let isInitialized = false;

function main() {
    // Prevent multiple initialization due to hot reloading
    if (isInitialized) {
        return;
    }

    // Track exceptions in Sentry
    initializeSentry({
        dsn: webConfig.sentry.dsn,
        release: releaseVersion,
        projectId: webConfig.firebase.projectId,
        tracesSampling: webConfig.sentry.tracesSampling,
        recordReplays: !!webConfig.sentry.recordReplays,
    });

    // Start firebase auth before even starting rendering to avoid async delay
    initializeAuth();

    isInitialized = true;

    const rootElement = document.getElementById('gitbook-root');
    assert(rootElement, 'Root element not found');
    const root = createRoot(rootElement);
    root.render(<Application />);
}

/**
 * Wait for the DOM to be interactive to continue and call `callback`.
 */
function waitDOMReady(callback: () => void) {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            callback();
        });
    }
}

waitDOMReady(() => {
    main();
});
